'use strict'

import React from 'react'

class LoadingError extends React.Component {
  render () {
    return (
      <div id='helpfaq' className='faq page container'>
        <div id='helpfaqcontent' tabIndex='-1' />
        <div className='container ask-tpl-container'>
          <h2 className='page__title'>Something went wrong!</h2>
          <p className='page__content'>We were unable to create this page, please try reloading it.</p>
          <p>
            <a href='/help/' className='faq__button' data-el='btn-back-to-help-home'>
              <span className='argos-icon icon-UIE-Controls-Chevron-Left' aria-hidden='true' />
              Back to help home
            </a>
          </p>
        </div>
      </div>
    )
  }
}

export default LoadingError
